import React from 'react';
import block from 'bem-cn';
import './Switcher.scss';

const b = block('switcher');

const Switcher = ({ isActive, onSwitch, isMobile, color, disabled }) => {
  return (
    <div
      className={b({ active: isActive, mobile: isMobile, color, disabled })}
      onClick={() => {
        if (!disabled) onSwitch(ps => !ps);
      }}>
      <div className={b('indicator')} />
    </div>
  );
};

export default Switcher;
